// Copyright (c) 2017 Deere & Company

import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import actions from '../../actions-list';
import filterOptions from '../../shared/constants/pip-products-filter-options';

export const updateListFilterBy = filterBy =>
    (dispatch, getState) => {

        const {pipProducts} = getState().pips.openPips;

        dispatch({
            data: filterCollection(filterBy, filterOptions, pipProducts),
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            filterBy,
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTER_BY
        });

    };

export const updateListSortBy = sortBy =>
    (dispatch, getState) => {

        const {pipProductsFiltered} = getState().pips.openPips;
        const {sortDirection} = getState().pips.openPips.searchFilters;

        dispatch({
            data: sortCollection(sortBy, sortDirection, pipProductsFiltered),
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            sortBy,
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_SORT_BY
        });

    };

export const updateListSortDirection = sortDirection =>
    (dispatch, getState) => {

        const {pipProductsFiltered} = getState().pips.openPips;
        const {sortBy} = getState().pips.openPips.searchFilters;

        dispatch({
            data: sortCollection(sortBy, sortDirection, pipProductsFiltered),
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_FILTERED
        });

        dispatch({
            sortDirection,
            type: actions.UPDATE_OPEN_PIP_PRODUCTS_SORT_DIRECTION
        });

    };



// WEBPACK FOOTER //
// ./src/pip/open-pips/action-creators/search-filters.js